/**
 * @fileoverview AI Evaluation Module
 * @description Routes the evaluation workspace: projects, scenarios, and runs.
 */

import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { ProjectsPage } from './ProjectsPage';
import { ProjectPage } from './ProjectPage';
import { CyclePage } from './CyclePage';
import { ScenarioPage } from './ScenarioPage';
import { RunPage } from './RunPage';
import { loadProjects } from '../utils/evaluationStore';
import './AIEvaluationResults.css';

/**
 * Render the AI evaluation workspace.
 * @returns {JSX.Element} Module routes.
 */
export function AIEvaluationResults() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    setProjects(loadProjects());
  }, []);

  const pageProps = { projects, onProjectsChange: setProjects };

  return (
    <Box className="aier-page">
      <Routes>
        <Route index element={<ProjectsPage {...pageProps} />} />
        <Route path=":projectId" element={<ProjectPage {...pageProps} />} />
        <Route path=":projectId/:cycleId" element={<CyclePage {...pageProps} />} />
        <Route path=":projectId/:cycleId/:scenarioId" element={<ScenarioPage {...pageProps} />} />
        <Route path=":projectId/:cycleId/:scenarioId/:runId" element={<RunPage {...pageProps} />} />
      </Routes>
    </Box>
  );
}

export default AIEvaluationResults;
